<div class="contact">
  <div class="row">
    <div class="col-md-12">
      <div class="seperator-headline">
        <div class="seperator-headline__line"></div>
        <h5>Kontakt</h5>
      </div>
      <div class="content-wrapper card-shadow">
        <ng-container *ngIf="hasContact; else noContact">
          <div *ngFor="let page of teamContact">
            <div *ngIf="page.isMailPage() || page.isPhonePage(); else otherContactElement"><b>{{ page.name }}: </b><a href="{{ page.urlRef }}">{{ page.url }}</a></div>
            <ng-template #otherContactElement>
              <div *ngIf="page.url && page.isContactInfo()"><b>{{ page.name }}: </b><a href="{{ page.urlRef }}">{{ page.url }}</a></div>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #noContact>
          Für dieses Team wurden noch kein Kontaktinfos angegeben!
        </ng-template>
      </div>
    </div>
    <div class="col-md-12" *ngIf="hasLinks">
      <div class="seperator-headline">
        <div class="seperator-headline__line"></div>
        <h5>Links</h5>
      </div>
      <div class="content-wrapper team-contact__socials card-shadow">
        <div class="team-contact__inner">
          <ng-container *ngFor="let page of socialMediaElements">
            <div class="team-contact__sm-btn">
              <a href="{{ page.urlRef }}" target="_blank"><div class="icon__sm icon__{{ page.name }}">{{ page.name }}</div></a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
